export const jewelryPriceHelper = (jewelry, markupType, currency) => {
  if (!jewelry) {
    return ''
  }
  if (markupType === 'CP') {
    return jewelry[`cost_price_in_${currency}`]
  } else if (markupType === 'BP') {
    return jewelry[`base_price_in_${currency}`]
  } else if (markupType === 'SP') {
    return jewelry[`sale_price_in_${currency}`]
  }
}

export const diamondPriceHelper = (diamond, markupType, currency) => {
  if (!diamond) {
    return ''
  }
  currency = currency.toUpperCase()
  if (markupType === 'CP') {
    return diamond[`Cost Price ${currency}`]
  } else if (markupType === 'BP') {
    return diamond[`Base Price ${currency}`]
  } else if (markupType === 'SP') {
    return diamond[`Sale Price ${currency}`]
  }
}

export const appraisalCostHelper = (jewelry, currency) => {
  if (!jewelry) {
    return ''
  }
  return jewelry[`appraisalCostIn${currency.toUpperCase()}`]
}



// WEBPACK FOOTER //
// ./src/selectors/prices.js